import ScrollMagic from 'scrollmagic';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false,
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__scoring-credit',
        triggerHook: 0.95,
        reverse: false,
    })
    .setClassToggle('.l-page__scoring-credit .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__scroing-rules',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__scroing-rules .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__solution-features--scoring',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__solution-features--scoring .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__bg-gray',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__bg-gray .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);

});



// WEBPACK FOOTER //
// ./app/scripts/pages/solutions/scoring.js